<app-modal [header]="'Remover Ocorrência'"
  [isShow]="displayModal"
  [style]="'w-full max-w-lg'"
  (cancel)="displayModal = false; this.onCancelModal.emit();">

  <div>
    <div class="text-xs mb-10 space-y-2">
      <p>Ao remover esta ocorrência, todos os seus elementos, incluindo pedidos de contacto, serão imediatamente
      removidos da plataforma. Não será possível apresentar um desfecho para os demais utilizadores.</p>

      <p class="text-amber-800">Nota: No caso de remoção por um moderador ou administrador, a ocorrência permanecerá em
        um estado de pré-remoção, permitindo contestação pelo criador da ocorrência ou averiguação de possíveis erros.
      </p>
    </div>


    <form method="POST" class="space-y-4" [formGroup]="form" (ngSubmit)="onSubmit()">

      @if (!isEventOwner) {
        <div class="my-10">
          <app-text-area-input [formGroup]="form" [id]="'reason'"
            [label]="'Motivo de remoção da ocorrência'"
            [placeholder]="'Motivo de remoção da ocorrência'"
            [value]="form.value?.reason"
            [formError]="outcomeFormError"
            [maxLength]="250">
          </app-text-area-input>
        </div>
      }
      <hr>

        <!-- submit button -->
        <div class="flex justify-end">
          <app-ae-button variant="danger" label="Remover ocorrência" [loading]="isLoading"
          (buttonClick)="onSubmit()" size="sm" styleClass="justify-end"></app-ae-button>
        </div>
      </form>
    </div>

  </app-modal>


